export class AuthorizeExternalController {
    static $inject = ['$state', 'LoadingService', 'AuthorizeServiceFactory'];
    constructor($state, LoadingService, AuthorizeServiceFactory) {
        'ngInject';
        this.$state = $state;
        this.LoadingService = LoadingService;
        this.AuthorizeServiceFactory = AuthorizeServiceFactory;
        this.LoadingService.startLoading(false);
    }
    async $onInit() {
        try {
            const user = await this.AuthorizeServiceFactory.signInRedirect();
            await this.AuthorizeServiceFactory.authenticate(user, { 'externalLogin': true });
        }
        catch (e) {
            console.error(e);
            this.$state.go('applicationError', { error: e });
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
AuthorizeExternalController.$inject = ['$state', 'LoadingService', 'AuthorizeServiceFactory'];
